// import { useEffect, useMemo, useState } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { db } from "../../firebase";
// import {
//   doc,
//   onSnapshot,
//   collection,
//   query,
//   where,
//   orderBy,
//   onSnapshot as onColSnapshot,
//   updateDoc,
//   serverTimestamp,
//   Timestamp,
//   runTransaction,
//   arrayUnion,
//   arrayRemove,
// } from "firebase/firestore";
// import { toast } from "react-hot-toast";
// import { ArrowLeft } from "lucide-react";

// /* helpers */
// const pad2 = (n) => String(n).padStart(2, "0");
// function symbolOf(code) {
//   switch (code) {
//     case "USD":
//       return "$";
//     case "EUR":
//       return "€";
//     case "GBP":
//       return "£";
//     case "INR":
//       return "₹";
//     case "LKR":
//       return "Rs";
//     default:
//       return code || "$";
//   }
// }

// const PAYMENT_WINDOW_MINUTES = 20;

// function Section({ title, count, children }) {
//   return (
//     <div className="mt-6">
//       <div className="flex items-center justify-between mb-2">
//         <h3 className="font-semibold">{title}</h3>
//         <span className="text-xs px-2 py-0.5 rounded bg-slate-700">
//           {count}
//         </span>
//       </div>
//       <div className="grid md:grid-cols-2 gap-3">{children}</div>
//       {!count && (
//         <div className="p-4 rounded-xl bg-slate-800 ring-1 ring-slate-700 text-slate-300">
//           No items here.
//         </div>
//       )}
//     </div>
//   );
// }

// export default function AgentQueues({ user }) {
//   const nav = useNavigate();
//   const { cardId: raw } = useParams();
//   const cardId = useMemo(() => {
//     try {
//       return decodeURIComponent(raw || "");
//     } catch {
//       return raw || "";
//     }
//   }, [raw]);

//   const [card, setCard] = useState(null);
//   const [loadingCard, setLoadingCard] = useState(true);

//   const [requested, setRequested] = useState([]); // status == requested
//   const [submitted, setSubmitted] = useState([]); // status == payment_submitted

//   useEffect(() => {
//     if (!raw) {
//       toast.error("No card id");
//       nav("/agent", { replace: true });
//     }
//   }, [raw, nav]);

//   // subscribe card
//   useEffect(() => {
//     if (!cardId) return;
//     setLoadingCard(true);
//     const ref = doc(db, "cards", cardId);
//     const un = onSnapshot(
//       ref,
//       (s) => {
//         setCard(s.exists() ? { id: s.id, ...s.data() } : null);
//         setLoadingCard(false);
//       },
//       (e) => {
//         console.error(e);
//         toast.error(`Card stream error: ${e.message}`);
//         setLoadingCard(false);
//       }
//     );
//     return () => un();
//   }, [cardId]);

//   // subscribe queues
//   useEffect(() => {
//     if (!user?.uid || !cardId) return;
//     const base = [
//       where("agentUid", "==", user.uid),
//       where("cardId", "==", cardId),
//     ];
//     const qRequested = query(
//       collection(db, "tickets"),
//       ...base,
//       where("status", "==", "requested"),
//       orderBy("requestedAt", "asc")
//     );
//     const qSubmitted = query(
//       collection(db, "tickets"),
//       ...base,
//       where("status", "==", "payment_submitted"),
//       orderBy("paymentSubmittedAt", "asc")
//     );

//     const un1 = onColSnapshot(qRequested, (snap) => {
//       const arr = [];
//       snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
//       setRequested(arr);
//     });
//     const un2 = onColSnapshot(qSubmitted, (snap) => {
//       const arr = [];
//       snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
//       setSubmitted(arr);
//     });
//     return () => {
//       un1();
//       un2();
//     };
//   }, [user?.uid, cardId]);

//   if (loadingCard) {
//     return (
//       <div className="max-w-5xl mx-auto mt-8 md:mt-16 p-4">
//         <div className="animate-pulse h-8 w-40 bg-slate-700 rounded mb-4" />
//         <div className="animate-pulse h-40 bg-slate-800 rounded-2xl" />
//       </div>
//     );
//   }

//   if (!card) {
//     return (
//       <div className="max-w-5xl mx-auto mt-8 md:mt-16 p-4">
//         <button
//           onClick={() => nav(-1)}
//           className="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl bg-slate-800 ring-1 ring-slate-700 hover:bg-slate-700"
//         >
//           <ArrowLeft size={16} /> Back
//         </button>
//         <div className="mt-6 p-6 rounded-2xl bg-slate-800 ring-1 ring-slate-700">
//           <div className="text-lg font-semibold">Card not found</div>
//           <div className="text-sm text-slate-300 mt-1">
//             (Tried: <code>{cardId}</code>)
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const currency = symbolOf(card.currency);
//   const unit = Number(card.pricePerNumber || 0);

//   // actions (no business rules/locks here; minimal happy path)
//   const approveRequest = async (t) => {
//     try {
//       const expiresAt = Timestamp.fromDate(
//         new Date(Date.now() + PAYMENT_WINDOW_MINUTES * 60 * 1000)
//       );

//       // ensure bundleId exists for grouped payments
//       const derivedBundle =
//         t.bundleId ||
//         `${t.agentUid || "agent"}|${
//           t.userUid || t.userMobileE164 || t.userMobile || "unknown"
//         }`;

//       await updateDoc(doc(db, "tickets", t.id), {
//         status: "agent_approved",
//         agentApprovedAt: serverTimestamp(),
//         paymentExpireAt: expiresAt, // future time, not "now"
//         paymentWindowMins: PAYMENT_WINDOW_MINUTES, // optional, handy for UI
//         bundleId: derivedBundle,
//         updatedAt: serverTimestamp(),
//       });
//       toast.success("Request approved");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Approve failed");
//     }
//   };

//   const declineRequest = async (t) => {
//     try {
//       await updateDoc(doc(db, "tickets", t.id), {
//         status: "payment_declined",
//         paymentDeclinedAt: serverTimestamp(),
//         updatedAt: serverTimestamp(),
//       });
//       toast.success("Request declined");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Decline failed");
//     }
//   };

//   // const approvePayment = async (t) => {
//   //   try {
//   //     await updateDoc(doc(db, "tickets", t.id), {
//   //       status: "payment_approved",
//   //       paymentApprovedAt: serverTimestamp(),
//   //       updatedAt: serverTimestamp(),
//   //     });
//   //     toast.success("Payment approved");
//   //   } catch (e) {
//   //     console.error(e);
//   //     toast.error(e.message || "Approve failed");
//   //   }
//   // };
//   const approvePayment = async (t) => {
//     try {
//       await runTransaction(db, async (tx) => {
//         const cardRef = doc(db, "cards", t.cardId);
//         const ticketRef = doc(db, "tickets", t.id);

//         const cardSnap = await tx.get(cardRef);
//         if (!cardSnap.exists()) throw new Error("Card not found.");
//         const card = cardSnap.data();

//         const unit = Number(t.unitPrice ?? card.pricePerNumber ?? 0);
//         const picked = Array.isArray(t.numbers) ? t.numbers : [];

//         // Only approve numbers that are not already sold
//         const filledSet = new Set(card.filled || []);
//         const approvedNums = picked.filter((n) => !filledSet.has(n));
//         if (!approvedNums.length) {
//           // Still mark ticket as approved so UI progresses, but nothing to add
//           tx.update(ticketRef, {
//             status: "payment_approved",
//             paymentApprovedAt: serverTimestamp(),
//             allocated: true,
//             updatedAt: serverTimestamp(),
//           });
//           return;
//         }

//         const amount = Number((approvedNums.length * unit).toFixed(2));

//         tx.update(cardRef, {
//           filled: arrayUnion(...approvedNums),
//           locked: arrayRemove(...approvedNums),
//           todaySales: Number((card.todaySales || 0) + amount),
//         });

//         tx.update(ticketRef, {
//           status: "payment_approved",
//           paymentApprovedAt: serverTimestamp(),
//           ...(t.allocated ? { allocated: true } : {}), // preserve if it was agent-allocated
//           amount, // ensure ticket reflects exact approved amount
//           updatedAt: serverTimestamp(),
//         });
//       });

//       toast.success("Payment approved & numbers confirmed");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Approve failed");
//     }
//   };

//   const declinePayment = async (t) => {
//     try {
//       await updateDoc(doc(db, "tickets", t.id), {
//         status: "payment_declined",
//         paymentDeclinedAt: serverTimestamp(),
//         updatedAt: serverTimestamp(),
//       });
//       toast.success("Payment declined");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Decline failed");
//     }
//   };

//   return (
//     <div className="max-w-5xl mx-auto mt-8 md:mt-16 p-4">
//       {/* header */}
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => nav(-1)}
//             className="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl bg-slate-800 ring-1 ring-slate-700 hover:bg-slate-700"
//           >
//             <ArrowLeft size={16} /> Back
//           </button>
//           <div>
//             <div className="text-xl font-bold">
//               Queues · Card #{card.id.slice(0, 8)}…
//             </div>
//             <div className="text-xs text-slate-300">
//               Unit: {currency}
//               {unit.toFixed(2)} · Status:{" "}
//               <span className="capitalize">{card.status || "active"}</span>
//             </div>
//           </div>
//         </div>

//         <Link
//           to={`/agent/cards/${encodeURIComponent(card.id)}`}
//           className="px-3 py-1.5 rounded-xl bg-slate-800 ring-1 ring-slate-700 hover:bg-slate-700 text-sm"
//         >
//           Go to Card
//         </Link>
//       </div>

//       {/* Requested */}
//       <Section title="Requests waiting approval" count={requested.length}>
//         {requested.map((t) => {
//           const nums = Array.isArray(t.numbers) ? t.numbers : [];
//           const amount = Number(
//             t.amount || (t.unitPrice || unit) * nums.length
//           );
//           return (
//             <div
//               key={t.id}
//               className="p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700"
//             >
//               <div className="font-semibold">
//                 {t.userName || t.userUid?.slice(0, 6) || "Player"}
//               </div>
//               <div className="text-sm text-slate-300 mt-1">
//                 Numbers:{" "}
//                 <span className="font-mono">{nums.join(", ") || "-"}</span>
//               </div>
//               <div className="text-sm text-slate-300 mt-1">
//                 Amount:{" "}
//                 <b>
//                   {currency}
//                   {amount.toFixed(2)}
//                 </b>
//               </div>
//               <div className="mt-3 flex gap-2">
//                 <button
//                   onClick={() => approveRequest(t)}
//                   className="px-3 py-1.5 rounded-xl bg-lime-400 text-black font-semibold"
//                 >
//                   Approve & Send Payment Details
//                 </button>
//                 <button
//                   onClick={() => declineRequest(t)}
//                   className="px-3 py-1.5 rounded-xl bg-slate-700 text-white"
//                 >
//                   Decline
//                 </button>
//               </div>
//             </div>
//           );
//         })}
//       </Section>

//       {/* Submitted payments */}
//       <Section title="Payments to verify" count={submitted.length}>
//         {submitted.map((t) => {
//           const nums = Array.isArray(t.numbers) ? t.numbers : [];
//           const amount = Number(
//             t.amount || (t.unitPrice || unit) * nums.length
//           );
//           return (
//             <div
//               key={t.id}
//               className="p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700"
//             >
//               <div className="font-semibold">
//                 {t.userName || t.userUid?.slice(0, 6) || "Player"}
//               </div>
//               <div className="text-sm text-slate-300 mt-1">
//                 Numbers:{" "}
//                 <span className="font-mono">{nums.join(", ") || "-"}</span>
//               </div>
//               <div className="text-sm text-slate-300 mt-1">
//                 Amount:{" "}
//                 <b>
//                   {currency}
//                   {amount.toFixed(2)}
//                 </b>
//               </div>

//               {/* Optional: link to slip / evidence */}
//               {t.paymentProofUrl ? (
//                 <div className="mt-2 text-xs">
//                   <a
//                     href={t.paymentProofUrl}
//                     target="_blank"
//                     rel="noreferrer"
//                     className="underline text-slate-300"
//                   >
//                     View payment proof
//                   </a>
//                 </div>
//               ) : null}

//               <div className="mt-3 flex gap-2">
//                 <button
//                   onClick={() => approvePayment(t)}
//                   className="px-3 py-1.5 rounded-xl bg-lime-400 text-black font-semibold"
//                 >
//                   Approve Payment
//                 </button>
//                 <button
//                   onClick={() => declinePayment(t)}
//                   className="px-3 py-1.5 rounded-xl bg-slate-700 text-white"
//                 >
//                   Decline
//                 </button>
//               </div>
//             </div>
//           );
//         })}
//       </Section>
//     </div>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { db } from "../../firebase";
import {
  doc,
  onSnapshot,
  collection,
  query,
  where,
  orderBy,
  onSnapshot as onColSnapshot,
  updateDoc,
  serverTimestamp,
  Timestamp,
  runTransaction,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { toast } from "react-hot-toast";
import { ArrowLeft } from "lucide-react";

/* ───────── helpers ───────── */
const pad2 = (n) => String(n).padStart(2, "0");
function symbolOf(code) {
  switch (code) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "INR":
      return "₹";
    case "LKR":
      return "Rs";
    default:
      return code || "$";
  }
}
const PAYMENT_WINDOW_MINUTES = 20;
const SKEW_MS = 2000; // 2s clock skew tolerance

// derive a stable bundle key so we can group by buyer
function deriveBundleKey(t) {
  if (t.bundleId) return t.bundleId;
  const userKey = t.userUid || t.userMobileE164 || t.userMobile || "unknown";
  const agentKey = t.agentUid || "agent";
  return `${agentKey}|${userKey}`;
}
// friendly user label
function displayUser(t) {
  return (
    t.userName ||
    t.username ||
    t.email ||
    (t.userMobileE164 ? `Mobile ${String(t.userMobileE164).slice(-4)}` : "") ||
    (t.userUid ? t.userUid.slice(0, 6) : "Buyer")
  );
}
// merge tickets to bundle groups with totals
function groupTickets(tickets) {
  const map = new Map();
  for (const t of tickets) {
    const key = deriveBundleKey(t);
    const g = map.get(key) || {
      key,
      agentUid: t.agentUid || null,
      userLabel: displayUser(t),
      currency: t.currency || "USD",
      tickets: [],
      totalAmount: 0,
      totalNumbers: 0,
      earliestAt: null,
      anyProof: false,
    };

    const nums = Array.isArray(t.numbers) ? t.numbers.length : 0;
    const unit = Number(t.unitPrice || 0);
    const amt = Number(t.amount || unit * nums);

    g.tickets.push(t);
    g.totalAmount += amt;
    g.totalNumbers += nums;

    const at =
      t.paymentSubmittedAt?.toDate?.() ||
      t.requestedAt?.toDate?.() ||
      t.createdAt?.toDate?.() ||
      null;
    if (at && (!g.earliestAt || at < g.earliestAt)) g.earliestAt = at;

    g.anyProof =
      g.anyProof ||
      !!t.paymentProofUrl ||
      !!t.proofUrl ||
      !!t.referenceId ||
      !!t.paymentRef;

    map.set(key, g);
  }

  // newest first by earliestAt
  return Array.from(map.values()).sort(
    (a, b) =>
      (b.earliestAt?.getTime?.() || 0) - (a.earliestAt?.getTime?.() || 0)
  );
}

/* ───────── Section shell ───────── */
function Section({ title, count, children }) {
  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold">{title}</h3>
        <span className="text-xs px-2 py-0.5 rounded bg-slate-700">
          {count}
        </span>
      </div>
      <div className="rounded-2xl overflow-hidden ring-1 ring-slate-700">
        {children}
      </div>
      {!count && (
        <div className="mt-2 p-4 rounded-xl bg-slate-800 ring-1 ring-slate-700 text-slate-300">
          No items here.
        </div>
      )}
    </div>
  );
}

/* ───────── Page ───────── */
export default function AgentQueues({ user }) {
  const nav = useNavigate();
  const { cardId: raw } = useParams();
  const cardId = useMemo(() => {
    try {
      return decodeURIComponent(raw || "");
    } catch {
      return raw || "";
    }
  }, [raw]);

  const [card, setCard] = useState(null);
  const [loadingCard, setLoadingCard] = useState(true);

  const [requested, setRequested] = useState([]); // status == requested
  const [submitted, setSubmitted] = useState([]); // status == payment_submitted

  useEffect(() => {
    if (!raw) {
      toast.error("No card id");
      nav("/agent", { replace: true });
    }
  }, [raw, nav]);

  // subscribe card
  useEffect(() => {
    if (!cardId) return;
    setLoadingCard(true);
    const ref = doc(db, "cards", cardId);
    const un = onSnapshot(
      ref,
      (s) => {
        setCard(s.exists() ? { id: s.id, ...s.data() } : null);
        setLoadingCard(false);
      },
      (e) => {
        console.error(e);
        toast.error(`Card stream error: ${e.message}`);
        setLoadingCard(false);
      }
    );
    return () => un();
  }, [cardId]);

  // subscribe queues for this card
  useEffect(() => {
    if (!user?.uid || !cardId) return;
    const base = [
      where("agentUid", "==", user.uid),
      where("cardId", "==", cardId),
    ];

    const qRequested = query(
      collection(db, "tickets"),
      ...base,
      where("status", "==", "requested"),
      orderBy("requestedAt", "asc")
    );
    const qSubmitted = query(
      collection(db, "tickets"),
      ...base,
      where("status", "==", "payment_submitted"),
      orderBy("paymentSubmittedAt", "asc")
    );

    const un1 = onColSnapshot(qRequested, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setRequested(arr);
    });
    const un2 = onColSnapshot(qSubmitted, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setSubmitted(arr);
    });
    return () => {
      un1();
      un2();
    };
  }, [user?.uid, cardId]);

  if (loadingCard) {
    return (
      <div className="max-w-5xl mx-auto mt-8 md:mt-16 p-4">
        <div className="animate-pulse h-8 w-40 bg-slate-700 rounded mb-4" />
        <div className="animate-pulse h-40 bg-slate-800 rounded-2xl" />
      </div>
    );
  }
  if (!card) {
    return (
      <div className="max-w-5xl mx-auto mt-8 md:mt-16 p-4">
        <button
          onClick={() => nav(-1)}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl bg-slate-800 ring-1 ring-slate-700 hover:bg-slate-700"
        >
          <ArrowLeft size={16} /> Back
        </button>
        <div className="mt-6 p-6 rounded-2xl bg-slate-800 ring-1 ring-slate-700">
          <div className="text-lg font-semibold">Card not found</div>
          <div className="text-sm text-slate-300 mt-1">
            (Tried: <code>{cardId}</code>)
          </div>
        </div>
      </div>
    );
  }

  const currencySym = symbolOf(card.currency);
  const unit = Number(card.pricePerNumber || 0);

  /* ───────── single-ticket actions ───────── */

  // approve request → move to agent_approved with expiry and bundleId
  const approveRequest = async (t) => {
    try {
      const expiresAt = Timestamp.fromDate(
        new Date(Date.now() + PAYMENT_WINDOW_MINUTES * 60 * 1000 + SKEW_MS)
      );
      const derivedBundle =
        t.bundleId ||
        `${t.agentUid || "agent"}|${
          t.userUid || t.userMobileE164 || t.userMobile || "unknown"
        }`;

      await updateDoc(doc(db, "tickets", t.id), {
        status: "agent_approved",
        agentApprovedAt: serverTimestamp(),
        paymentExpireAt: expiresAt,
        paymentWindowMins: PAYMENT_WINDOW_MINUTES,
        bundleId: derivedBundle,
        updatedAt: serverTimestamp(),
      });
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Approve failed");
    }
  };

  const declineRequest = async (t) => {
    try {
      await updateDoc(doc(db, "tickets", t.id), {
        status: "payment_declined",
        paymentDeclinedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Decline failed");
    }
  };

  // approve payment transactionally → fill numbers & todaySales
  const approvePayment = async (t) => {
    try {
      await runTransaction(db, async (tx) => {
        const cardRef = doc(db, "cards", t.cardId);
        const ticketRef = doc(db, "tickets", t.id);

        const cardSnap = await tx.get(cardRef);
        if (!cardSnap.exists()) throw new Error("Card not found.");
        const c = cardSnap.data();

        const unitPrice = Number(t.unitPrice ?? c.pricePerNumber ?? 0);
        const picked = Array.isArray(t.numbers) ? t.numbers : [];

        const filledSet = new Set(c.filled || []);
        const approvedNums = picked.filter((n) => !filledSet.has(n));

        // mark ticket approved regardless; if zero, nothing to add
        const amount = Number((approvedNums.length * unitPrice).toFixed(2));

        if (approvedNums.length) {
          tx.update(cardRef, {
            filled: arrayUnion(...approvedNums),
            locked: arrayRemove(...approvedNums),
            todaySales: Number((c.todaySales || 0) + amount),
          });
        }

        tx.update(ticketRef, {
          status: "payment_approved",
          paymentApprovedAt: serverTimestamp(),
          allocated: t.allocated ? true : undefined,
          amount,
          updatedAt: serverTimestamp(),
        });
      });
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Approve failed");
    }
  };

  const declinePayment = async (t) => {
    try {
      await updateDoc(doc(db, "tickets", t.id), {
        status: "payment_declined",
        paymentDeclinedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Decline failed");
    }
  };

  /* ───────── group wrappers (batch) ───────── */
  const approveRequestGroup = async (g) => {
    try {
      await Promise.all(g.tickets.map((t) => approveRequest(t)));
      toast.success(`Approved ${g.tickets.length} request(s).`);
    } catch {}
  };
  const approvePaymentGroup = async (g) => {
    try {
      // sequential keeps contention low on the same card doc
      for (const t of g.tickets) {
        await approvePayment(t);
      }
      toast.success(`Approved ${g.tickets.length} payment(s).`);
    } catch {}
  };
  const declineGroup = async (g, kind) => {
    try {
      if (kind === "request") {
        await Promise.all(g.tickets.map((t) => declineRequest(t)));
      } else {
        await Promise.all(g.tickets.map((t) => declinePayment(t)));
      }
      toast.success(`Declined ${g.tickets.length} item(s).`);
    } catch {}
  };

  /* ───────── derived groups ───────── */
  const groupedRequested = useMemo(() => groupTickets(requested), [requested]);
  const groupedSubmitted = useMemo(() => groupTickets(submitted), [submitted]);

  /* ───────── render ───────── */
  return (
    <div className="max-w-5xl mx-auto mt-8 md:mt-16 p-4">
      {/* header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={() => nav(-1)}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl bg-slate-800 ring-1 ring-slate-700 hover:bg-slate-700"
          >
            <ArrowLeft size={16} /> Back
          </button>
          <div>
            <div className="text-xl font-bold">
              Queues · Card #{card.id.slice(0, 8)}…
            </div>
            <div className="text-xs text-slate-300">
              Unit: {currencySym}
              {unit.toFixed(2)} · Status:{" "}
              <span className="capitalize">{card.status || "active"}</span>
            </div>
          </div>
        </div>

        <Link
          to={`/agent/cards/${encodeURIComponent(card.id)}`}
          className="px-3 py-1.5 rounded-xl bg-slate-800 ring-1 ring-slate-700 hover:bg-slate-700 text-sm"
        >
          Go to Card
        </Link>
      </div>

      {/* Requested (grouped) */}
      <Section
        title="Requests waiting approval"
        count={groupedRequested.length}
      >
        {/* header row */}
        <div className="grid grid-cols-[160px_1fr_160px_140px_260px] gap-2 px-3 py-2 bg-slate-900 text-xs text-slate-300">
          <div>Created</div>
          <div>User</div>
          <div className="text-right">Amount</div>
          <div className="text-right">Numbers</div>
          <div className="text-right">Actions</div>
        </div>
        {groupedRequested.map((g) => (
          <div
            key={g.key}
            className="grid grid-cols-[160px_1fr_160px_140px_260px] items-center gap-2 px-3 py-2 border-t border-slate-700 bg-slate-800"
          >
            <div className="text-slate-300">
              {g.earliestAt ? g.earliestAt.toLocaleString() : "—"}
            </div>
            <div className="font-semibold truncate">{g.userLabel}</div>
            <div className="text-right font-mono">
              {currencySym}
              {g.totalAmount.toFixed(2)}
            </div>
            <div className="text-right">{g.totalNumbers}</div>
            <div className="flex gap-2 justify-end">
              <button
                className="px-3 py-1.5 rounded bg-slate-700"
                onClick={() => {
                  // optional: open a review modal listing g.tickets
                  toast(`Requests: ${g.tickets.length}`);
                }}
              >
                Review
              </button>
              <button
                className="px-3 py-1.5 rounded bg-emerald-600 text-white"
                onClick={() => approveRequestGroup(g)}
              >
                Approve & Send
              </button>
              <button
                className="px-3 py-1.5 rounded bg-rose-600 text-white"
                onClick={() => declineGroup(g, "request")}
              >
                Decline
              </button>
            </div>
          </div>
        ))}
      </Section>

      {/* Submitted payments (grouped) */}
      <Section title="Payments to verify" count={groupedSubmitted.length}>
        <div className="grid grid-cols-[160px_1fr_160px_140px_160px_220px] gap-2 px-3 py-2 bg-slate-900 text-xs text-slate-300">
          <div>Submitted</div>
          <div>User</div>
          <div className="text-right">Amount</div>
          <div className="text-right">Numbers</div>
          <div>Receipt</div>
          <div className="text-right">Actions</div>
        </div>
        {groupedSubmitted.map((g) => (
          <div
            key={g.key}
            className="grid grid-cols-[160px_1fr_160px_140px_160px_220px] items-center gap-2 px-3 py-2 border-t border-slate-700 bg-slate-800"
          >
            <div className="text-slate-300">
              {g.earliestAt ? g.earliestAt.toLocaleString() : "—"}
            </div>
            <div className="font-semibold truncate">{g.userLabel}</div>
            <div className="text-right font-mono">
              {currencySym}
              {g.totalAmount.toFixed(2)}
            </div>
            <div className="text-right">{g.totalNumbers}</div>
            <div className="text-slate-300">
              {g.anyProof ? "Attached" : "—"}
            </div>
            <div className="flex gap-2 justify-end">
              <button
                className="px-3 py-1.5 rounded bg-slate-700"
                onClick={() => {
                  // optional: open proof viewer for all tickets
                  const withProof = g.tickets.filter(
                    (t) => t.paymentProofUrl || t.proofUrl
                  );
                  if (!withProof.length) toast("No receipts in this bundle");
                  else
                    window.open(
                      withProof[0].paymentProofUrl || withProof[0].proofUrl,
                      "_blank"
                    );
                }}
              >
                Review
              </button>
              <button
                className="px-3 py-1.5 rounded bg-emerald-600 text-white"
                onClick={() => approvePaymentGroup(g)}
              >
                Approve Payment
              </button>
              <button
                className="px-3 py-1.5 rounded bg-rose-600 text-white"
                onClick={() => declineGroup(g, "payment")}
              >
                Decline
              </button>
            </div>
          </div>
        ))}
      </Section>
    </div>
  );
}
